import React, { useEffect, useState } from 'react';
import './sec2.css'
import Cardsec2 from '../components/common/card-sec2';
import { useTranslation } from 'react-i18next';

const Sec2 = () => {

    const { t, i18n } = useTranslation();
    const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
    

 const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec2');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);











    return ( <>
    <section className={`sec2 ${animate ? 'animate' : ''}`} dir={direction}>
            <article className='sec-cont'>
                <article className='colum-sec2'>
                    <h1 className='header-sec2'>{t('Event Categories')}</h1>
                    <article className='cards-container-sec2'>
                        <Cardsec2 title={t('Pop & Commercial')} />
                        <Cardsec2 title={t('Classical & Orchestra')} />
                        <Cardsec2 title= {t('Electronic & DJ')} />
                        <Cardsec2 title={t('Indie & Alternative')}  />
                        <Cardsec2 title= {t('Rock & Metal')}/>
                        <Cardsec2 title={t('Cultural & Traditional')} />
                    </article>
                </article>
            </article>  
    </section>
    </> );
}
 
export default Sec2;